import { render } from "./App.vue?vue&type=template&id=43c7e8dc&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script